import { fetchWithAuth } from './auth';

export interface AppraisalContact {
  id: string;
  name: string | null;
  role: string | null;
  phone: string | null;
  email: string | null;
}

export interface AppraisalInspection {
  id: string;
  date: string | null;
  status: string | null;
  type: string | null;
  inspector: string | null;
  notes: string | null;
}

export interface AppraisalDetail {
  id: string;
  policyholder_name: string | null;
  policyholder_email: string | null;
  policyholder_phone: string | null;
  property_address: string | null;
  address_street: string | null;
  address_city: string | null;
  address_state: string | null;
  address_zip: string | null;
  carrier_name: string | null;
  policy_number: string | null;
  claim_number: string | null;
  loss_type: string | null;
  loss_date: string | null;
  status: string | null;
  created_at: string;
  inspections?: AppraisalInspection[];
  contacts?: AppraisalContact[];
}

export async function getAppraisal(id: string): Promise<AppraisalDetail> {
  const r = await fetchWithAuth(`/api/appraisals/${id}`);
  if (!r.ok) throw new Error(`getAppraisal failed: ${r.status}`);
  return (await r.json()) as AppraisalDetail;
}
